<template>
  <!-- // 三合一环境面板使用 -->
  <div class="config_main_manage_background">
    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->
        <config-title-hang>
          <span slot="config_title_hang_ele2">全部可选对象</span>
          <input slot="config_title_hang_ele8"
                 type="text"
                 placeholder="快速搜索"
                 v-model="scerchValue" />
        </config-title-hang>

        <!-- 服务器返回的所有区域列表 -->
        <config-hang v-for="(value , index) in serveObjectListData"
                     :key="index"
                     @click.native="selectObjectBtnHandle(value)"
                     :selectState="selectObjectID === value.deviceId">
          <span slot="config_hang_ele2">{{value.remark}}({{value.regionName}})</span>
          <img slot="config_hang_weixuan"
               src="~assets/img/config/weixuan.png"
               alt />
          <img slot="config_hang_xuanzhong"
               src="~assets/img/config/xuanzhong.png"
               alt />
        </config-hang>

        <div class="public_config_que_ren_btn"
             @click="saveReturnBtnHandle">保存并返回</div>
      </div>
    </div>
  </div>
</template>

<script>
import topNav from "components/common/topnav/topnav";
import topNavItem from "components/common/topnav/topnavitem";
import configHang from "components/common/config/config-hang";
import configTitleHang from "components/common/config/config-title-hang";
// import { mediumslateblue } from "color-name";
import { configPageDataRequest } from "views/afterLogin/config/deviceManagePage/deviceListPage/public_config_requery_js";

export default {
  data () {
    return {
      serveObjectListData: [
        ///服务器返回的对象列表数据
      ],
      serveObjectListDataBack: [
        //搜索使用
      ],
      scerchValue: "", // 搜索使用
      selectObjectID: "", ///当前选中的对象ID
      // businessIdDesc:"",//////当前选中的对象回显name
      ServeOneObjectinfo: {
        ////地址指向仓库  当前要进行设置对象的信息
      },
    };
  },
  components: {
    topNav,
    topNavItem,
    configHang,
    configTitleHang,
  },
  methods: {
    selectObjectBtnHandle (value) {
      // console.log("111111");
      this.selectObjectID = value.deviceId;
      // this.businessIdDesc = value.regionName + '(' + value.remark + ')'
    },
    saveReturnBtnHandle () {
      ///保存并返回按钮点击了
      if (this.selectObjectID === "") {
        this.$toast("请至少选择一个绑定的对象！");
        return;
      }

      /////处理一下入参
      let tempData = {
        token: this.$store.state.token,
        deviceId: this.ServeOneObjectinfo.deviceId, ////要进行绑定参数的设备ID
        deviceNo: "", ///
        buttonCode: "", ///触发类型	BUTTON_01("1", "单场景"), BUTTON_02("2", "双场景"),  	BUTTON_03("3", "通断"), BUTTON_04("4", "调光"),  	BUTTON_05("5", "电机")
        gatewayNo: "",
        businessId1: "",
        businessId2: "",
        businessId3: "",
        businessId4: "",
      };
      if (this.$route.query.type === "aircond") {
        ////绑定空调页面接口数据
        tempData.businessId1 = this.selectObjectID;
      } else if (this.$route.query.type === "floorheating") {
        ////绑定地暖页面接口数据
        tempData.businessId2 = this.selectObjectID;
      } else if (this.$route.query.type === "newtrend") {
        ////绑定新风页面接口数据
        tempData.businessId3 = this.selectObjectID;
      } else if (this.$route.query.type === "probe") {
        ////绑定环境探测页面接口数据
        tempData.businessId4 = this.selectObjectID;
      }
      /// 设置页面下发配置(通用) 接口
      configPageDataRequest(tempData)
        .then((res) => {
          console.log(res);

          // 获取设备详情 接口，获取数据  通过接口刷新页面数据
          this.$request({
            method: "post",
            url: "/device/findDeviceById",
            data: {
              token: this.$store.state.token,
              deviceId: this.ServeOneObjectinfo.deviceId,
            },
          })
            .then((res) => {
              if (res.data.code != 0) {
                this.$showTipsToast(3, res.data.message);
                ////说明信息填写错误,控制失败了，
                return;
              } else {
                ////、控制成功了 数据地址存到仓库
                this.$store.dispatch(
                  "asyUpdataServeOneObjectinfo",
                  res.data.data
                ); ///异步提交对象信息地址到仓库
                console.log(res.data.data);
                // 返回上一页面

                this.$router.go(-1);
                // this.$showTipsToast(1, "获取成功", true); ////提示框
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //业内数据搜索显示  //搜索使用
    seraceDataShow (charData) {
      if (this.serveObjectListData && this.serveObjectListDataBack) {
        //数据是合法存在的
        this.serveObjectListData = this.serveObjectListData.concat(
          this.serveObjectListDataBack
        );
        this.serveObjectListDataBack.length = 0;
        if (charData.match(/^[ ]*$/)) {
          //说明为空 或多个空
        } else {
          let dataLength = this.serveObjectListData.length;
          for (let i = 0; i < dataLength; i++) {
            if (
              (
                this.serveObjectListData[i].remark +
                this.serveObjectListData[i].regionName
              ).indexOf(charData) == -1
            ) {
              // && this.serveObjectListData[i].checked == false
              // 说明没有这个字符
              this.serveObjectListDataBack.push(this.serveObjectListData[i]);
              this.serveObjectListData.splice(i, 1);
              dataLength--;
              i--;
            }
          }
        }
        console.log(this.serveObjectListData);
      }
    }
  },
  watch: {
    scerchValue: function (val) {
      console.log("发生变化" + val);
      this.seraceDataShow(val); //新增页内搜索
    },
  },
  created () {
    console.log("created阶段");
    this.ServeOneObjectinfo = this.$store.state.configinfo.ServeOneObjectinfo; ////一个对象的地址信息拿过来
    console.log(this.ServeOneObjectinfo);
    /// 根据产品码获取设备对象 接口，获取数据
    this.$request({
      method: "post",
      url: "/device/findDeviceListByProductCode",
      data: {
        token: this.$store.state.token,
        productCode: this.$route.query.productCode,
        //gatewayId当不传或为空时. 默认列出账号下所有设备. 传时,列出对应网关下的设备.
        gatewayId: this.ServeOneObjectinfo.gatewayId,  //修复BUG 选择可控设备时不会过滤当前网关的设备  //代号 20231202-1
      },
    })
      .then((res) => {
        if (res.data.code != 0) {
          this.$showTipsToast(3, res.data.message);
          ////说明信息填写错误,控制失败了，
          return;
        } else {
          ////、控制成功了
          this.serveObjectListData = res.data.data; ////拿到服务器返回的数据结果
          ////插入一行不绑定任何设备时的数据
          this.serveObjectListData.splice(0, 0, {
            deviceId: "0",
            regionName: "不绑定任何设备",
            remark: "无",
          });
          console.log(this.serveObjectListData);

          // this.$showTipsToast(1, "获取成功", true); ////提示框
        }
      })
      .catch((error) => {
        console.log(error);
      });

    this.selectObjectID = this.$route.query.businessId; ///把已经绑定的ID得到
    console.log(this.selectObjectID);

    // this.OneSceneinfo = this.$store.state.configinfo.OneSceneinfo;
    //需要把进来时的仓库的状态更新进来，根据页面进来的类型进行判断
    // if (this.$route.query.type === 1) {
    //   ///1代表是场景页面进来 选择区域的  进来的时候需要判断拉取数据
    //   this.OneSceneObjectinfo.regionName = this.$store.state.configinfo.OneSceneinfo.regionName;
    //   this.OneSceneObjectinfo.regionId = this.$store.state.configinfo.OneSceneinfo.regionId;
    // } else if (this.$route.query.type === 2) {
    //   ///2代表是对象页面进来 选择区域的  进来的时候需要判断拉取数据
    //   this.OneSceneObjectinfo.regionName = this.$store.state.configinfo.ServeOneObjectinfo.regionName;
    //   this.OneSceneObjectinfo.regionId = this.$store.state.configinfo.ServeOneObjectinfo.regionId;
    // }
  },
};
</script>

<style>
</style>